/**
 * Internal dependencies
 */
import { getDocumentHeight } from './utils';
import { domReady } from '../../../../public/utils/helpers';

const SCROLL_STEP_IN_PX = 1000;

let _isPageReady = false;
export const isPageReady = (): boolean => _isPageReady;

let prq: ( () => void )[] = [];
export const onPageReady = ( cb: () => void ): void =>
	void ( isPageReady() ? cb() : prq.push( cb ) );

let _once = false;
export const loadAssets = (): void => {
	if ( _once ) {
		return;
	}
	_once = true;
	domReady( () => void doLoadPage() );
};

export const disableLinks = (): void =>
	Array.from( document.querySelectorAll( 'a' ) ).forEach( ( link ) =>
		link.setAttribute( 'href', '#' )
	);

// =======
// HELPERS
// =======

async function doLoadPage() {
	fetchLazyLoadImages();
	await scanPage();
	await wait( 2000 );
	markPageAsLoaded();
}

function fetchLazyLoadImages(): void {
	const images = Array.from(
		document.querySelectorAll< HTMLElement >( 'img[data-src]' )
	).reverse();
	images.forEach( ( img ) => {
		const src = img.getAttribute( 'data-src' );
		if ( src ) {
			img.setAttribute( 'src', src );
		}
	} );
}

async function scanPage(): Promise< void > {
	const height = getDocumentHeight();

	for ( let i = SCROLL_STEP_IN_PX; i < height; i += SCROLL_STEP_IN_PX ) {
		window.scrollTo( 0, i );
		await wait( 100 );
	}

	window.scrollTo( 0, 0 );
}

function wait( ms: number ): Promise< void > {
	return new Promise( ( resolve ) => setTimeout( resolve, ms ) );
}

function markPageAsLoaded(): void {
	_isPageReady = true;
	prq.forEach( ( f ) => f() );
	prq = [];
}
